import './loading-screen.css';

export interface LoadingScreenOptions {
  logo?: HTMLElement | string;
  tip?: string;
  initialProgress?: number;
}

export interface LoadingScreenHandle {
  readonly el: HTMLElement;
  setProgress(fraction: number): void;
  setTip(text: string): void;
  show(): void;
  hide(): void;
  destroy(): void;
}

function clamp01(v: number): number {
  return Math.max(0, Math.min(1, v));
}

export function createLoadingScreen(opts: LoadingScreenOptions = {}): LoadingScreenHandle {
  const el = document.createElement('div');
  el.className = 'fg-loading';

  const logoWrap = document.createElement('div');
  logoWrap.className = 'fg-loading__logo';
  if (opts.logo instanceof HTMLElement) {
    logoWrap.appendChild(opts.logo);
  } else if (typeof opts.logo === 'string') {
    const img = document.createElement('img');
    img.src = opts.logo;
    img.alt = '';
    logoWrap.appendChild(img);
  } else {
    const ph = document.createElement('div');
    ph.className = 'fg-loading__logo--placeholder';
    ph.textContent = 'logo';
    logoWrap.appendChild(ph);
  }
  el.appendChild(logoWrap);

  const track = document.createElement('div');
  track.className = 'fg-loading__track';
  const fill = document.createElement('div');
  fill.className = 'fg-loading__fill';
  track.appendChild(fill);
  el.appendChild(track);

  const label = document.createElement('div');
  label.className = 'fg-loading__label';
  el.appendChild(label);

  const tipEl = document.createElement('div');
  tipEl.className = 'fg-loading__tip';
  el.appendChild(tipEl);

  function setProgress(fraction: number) {
    const f = clamp01(fraction);
    fill.style.width = `${Math.round(f * 100)}%`;
    label.textContent = `Loading… ${Math.round(f * 100)}%`;
  }

  function setTip(text: string) {
    tipEl.textContent = text ? `💡 ${text}` : '';
  }

  setProgress(opts.initialProgress ?? 0);
  setTip(opts.tip ?? '');

  return {
    el,
    setProgress,
    setTip,
    show() {
      el.classList.add('fg-loading--open');
    },
    hide() {
      el.classList.remove('fg-loading--open');
    },
    destroy() {
      el.remove();
    },
  };
}
